/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { FormTransformations } from "../../../types/ProductService/ProductService";
import abstractLitigationCaseTransformations from "./abstractLitigationCaseTransformations";

const generalCivilLawTransformations: FormTransformations = {
  dateFields: [...abstractLitigationCaseTransformations.dateFields!,
    { path: "client.birthDate", type: "date" },
    { path: "incidentDate", type: "date" },
  ],
  numberFields: abstractLitigationCaseTransformations.numberFields,
  timeFields: [...abstractLitigationCaseTransformations.timeFields!],
  floatFields: [...abstractLitigationCaseTransformations.floatFields!],
  ibanFields: abstractLitigationCaseTransformations.ibanFields,
};
export default generalCivilLawTransformations;
